import PropTypes from 'prop-types'

import getSitesForStaticPaths from 'helpers/getSitesForStaticPaths'
import ABOUT_QUERY from 'graphql/about.query'

import Layout from 'components/Layout'
import WordpressSEO from 'components/WordpressSEO'
import Blocks from 'components/Blocks'

import s from './about.module.css'
import StateInitializer from '../../components/StateInitializer'
import getGlobalSettings from '../../helpers/getGlobalSettings'
import getSites from '../../helpers/getSites'
import { createApolloClient } from '../../lib/createApolloClient'
import * as Sentry from '@sentry/nextjs'

//TODO: Add proptypes
function About({ globalSettings, sites, siteSlug, acfBlocks = {}, site = '' }) {
  return (
    <StateInitializer
      globalSettings={globalSettings}
      sites={sites}
      siteSlug={siteSlug}
    >
      <Layout globalSettings={globalSettings}>
        <WordpressSEO url={`/${site}/about`} title="About" />
        <div className={s.container}>
          {acfBlocks && <Blocks postType="Page">{acfBlocks}</Blocks>}
        </div>
      </Layout>
    </StateInitializer>
  )
}

About.propTypes = {
  globalSettings: PropTypes.object.isRequired,
  sites: PropTypes.array.isRequired,
  siteSlug: PropTypes.string.isRequired,
}

export default About

export async function getStaticProps({ params }) {
  const { site } = params

  const apolloClient = createApolloClient()

  const [globalSettings, sites, { data, error }] = await Promise.all([
    getGlobalSettings(site),
    getSites(),
    apolloClient.query({
      query: ABOUT_QUERY,
      context: { site },
      variables: {
        slug: 'about',
      },
    }),
  ])

  if (error) {
    Sentry.addBreadcrumb({
      category: 'getStaticProps',
      message: `Error loading About props for site ${site}`,
      level: 'error',
      data: { params, error },
    })
    Sentry.captureException(new Error(`Error loading About props - ${error}`))
    console.error(`Error loading About props - ${error}`)
  }

  return {
    props: {
      ...params,
      ...data.pageBy,
      globalSettings,
      sites,
      siteSlug: site,
    },
    revalidate: 60 * 60 * 24, // 24 hours
  }
}

export async function getStaticPaths() {
  const sites = await getSitesForStaticPaths()

  const paths = sites.map((site) => ({
    params: {
      site: site,
    },
  }))

  return {
    paths,
    fallback: false,
  }
}
